import { SubscriptionPanel } from "../components/SubscriptionPanel"

/** /subscription route: the panel with a page heading. */
export function SubscriptionPage() {
  return (
    <main className="sub-page" aria-labelledby="subscription-title">
      <h1 id="subscription-title">Subscription</h1>
      <SubscriptionPanel />
    </main>
  )
}
